import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PortCommonTableComponent } from './port-common-table.component';

const routes: Routes = [
  {
    path: '',
    component: PortCommonTableComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PortCommonTableRoutingModule {}
